import { CreateSeasonThreeUserResponse } from "../../types/rewards";

export const createSeasonThreeUserModel = (
  response: CreateSeasonThreeUserResponse
): CreateSeasonThreeUserResponse => response;
